export const COUNTRIES = [
  $localize`:@@countries.afghanistan:Afghanistan`,
  $localize`:@@countries.albania:Albania`,
  $localize`:@@countries.algeria:Algeria`,
  $localize`:@@countries.andorra:Andorra`,
  $localize`:@@countries.angola:Angola`,
  $localize`:@@countries.anguilla:Anguilla`,
  $localize`:@@countries.antigua:Antigua &amp; Barbuda`,
  $localize`:@@countries.argentina:Argentina`,
  $localize`:@@countries.armenia:Armenia`,
  $localize`:@@countries.aruba:Aruba`,
  $localize`:@@countries.australia:Australia`,
  $localize`:@@countries.austria:Austria`,
  $localize`:@@countries.azerbaijan:Azerbaijan`,
  $localize`:@@countries.bahamas:Bahamas`,
  $localize`:@@countries.bahrain:Bahrain`,
  $localize`:@@countries.bangladesh:Bangladesh`,
  $localize`:@@countries.barbados:Barbados`,
  $localize`:@@countries.belarus:Belarus`,
  $localize`:@@countries.belgium:Belgium`,
  $localize`:@@countries.belize:Belize`,
  $localize`:@@countries.benin:Benin`,
  $localize`:@@countries.bermuda:Bermuda`,
  $localize`:@@countries.bhutan:Bhutan`,
  $localize`:@@countries.bolivia:Bolivia`,
  $localize`:@@countries.bosnia:Bosnia &amp; Herzegovina`,
  $localize`:@@countries.botswana:Botswana`,
  $localize`:@@countries.brazil:Brazil`,
  $localize`:@@countries.britishVirginIslands:British Virgin Islands`,
  $localize`:@@countries.brunei:Brunei`,
  $localize`:@@countries.bulgaria:Bulgaria`,
  $localize`:@@countries.burkinaFaso:Burkina Faso`,
  $localize`:@@countries.burundi:Burundi`,
  $localize`:@@countries.cambodia:Cambodia`,
  $localize`:@@countries.cameroon:Cameroon`,
  $localize`:@@countries.capeVerde:Cape Verde`,
  $localize`:@@countries.caymanIslands:Cayman Islands`,
  $localize`:@@countries.chad:Chad`,
  $localize`:@@countries.chile:Chile`,
  $localize`:@@countries.china:China`,
  $localize`:@@countries.colombia:Colombia`,
  $localize`:@@countries.congo:Congo`,
  $localize`:@@countries.cookIslands:Cook Islands`,
  $localize`:@@countries.costaRica:Costa Rica`,
  $localize`:@@countries.coteDIvoire:Cote D Ivoire`,
  $localize`:@@countries.croatia:Croatia`,
  $localize`:@@countries.cruiseShip:Cruise Ship`,
  $localize`:@@countries.cuba:Cuba`,
  $localize`:@@countries.cyprus:Cyprus`,
  $localize`:@@countries.czechRepublic:Czech Republic`,
  $localize`:@@countries.denmark:Denmark`,
  $localize`:@@countries.djibouti:Djibouti`,
  $localize`:@@countries.dominica:Dominica`,
  $localize`:@@countries.dominicanRepublic:Dominican Republic`,
  $localize`:@@countries.ecuador:Ecuador`,
  $localize`:@@countries.egypt:Egypt`,
  $localize`:@@countries.elSalvador:El Salvador`,
  $localize`:@@countries.equatorialGuinea:Equatorial Guinea`,
  $localize`:@@countries.estonia:Estonia`,
  $localize`:@@countries.ethiopia:Ethiopia`,
  $localize`:@@countries.falklandIslands:Falkland Islands`,
  $localize`:@@countries.faroeIslands:Faroe Islands`,
  $localize`:@@countries.fiji:Fiji`,
  $localize`:@@countries.finland:Finland`,
  $localize`:@@countries.france:France`,
  $localize`:@@countries.frenchPolynesia:French Polynesia`,
  $localize`:@@countries.frenchWestIndies:French West Indies`,
  $localize`:@@countries.gabon:Gabon`,
  $localize`:@@countries.gambia:Gambia`,
  $localize`:@@countries.georgia:Georgia`,
  $localize`:@@countries.germany:Germany`,
  $localize`:@@countries.ghana:Ghana`,
  $localize`:@@countries.gibraltar:Gibraltar`,
  $localize`:@@countries.greece:Greece`,
  $localize`:@@countries.greenland:Greenland`,
  $localize`:@@countries.grenada:Grenada`,
  $localize`:@@countries.guam:Guam`,
  $localize`:@@countries.guatemala:Guatemala`,
  $localize`:@@countries.guernsey:Guernsey`,
  $localize`:@@countries.guinea:Guinea`,
  $localize`:@@countries.guineaBissau:Guinea Bissau`,
  $localize`:@@countries.guyana:Guyana`,
  $localize`:@@countries.haiti:Haiti`,
  $localize`:@@countries.honduras:Honduras`,
  $localize`:@@countries.hongKong:Hong Kong`,
  $localize`:@@countries.hungary:Hungary`,
  $localize`:@@countries.iceland:Iceland`,
  $localize`:@@countries.india:India`,
  $localize`:@@countries.indonesia:Indonesia`,
  $localize`:@@countries.iran:Iran`,
  $localize`:@@countries.iraq:Iraq`,
  $localize`:@@countries.ireland:Ireland`,
  $localize`:@@countries.isleOfMan:Isle of Man`,
  $localize`:@@countries.israel:Israel`,
  $localize`:@@countries.italy:Italy`,
  $localize`:@@countries.jamaica:Jamaica`,
  $localize`:@@countries.japan:Japan`,
  $localize`:@@countries.jersey:Jersey`,
  $localize`:@@countries.jordan:Jordan`,
  $localize`:@@countries.kazakhstan:Kazakhstan`,
  $localize`:@@countries.kenya:Kenya`,
  $localize`:@@countries.kuwait:Kuwait`,
  $localize`:@@countries.kyrgyzRepublic:Kyrgyz Republic`,
  $localize`:@@countries.laous:Laos`,
  $localize`:@@countries.latvia:Latvia`,
  $localize`:@@countries.lebanon:Lebanon`,
  $localize`:@@countries.lesotho:Lesotho`,
  $localize`:@@countries.liberia:Liberia`,
  $localize`:@@countries.libya:Libya`,
  $localize`:@@countries.liechtenstein:Liechtenstein`,
  $localize`:@@countries.lithunia:Lithuania`,
  $localize`:@@countries.luxemburg:Luxembourg`,
  $localize`:@@countries.macau:Macau`,
  $localize`:@@countries.macedonia:Macedonia`,
  $localize`:@@countries.madagascar:Madagascar`,
  $localize`:@@countries.malawi:Malawi`,
  $localize`:@@countries.malaysia:Malaysia`,
  $localize`:@@countries.maldives:Maldives`,
  $localize`:@@countries.mali:Mali`,
  $localize`:@@countries.malta:Malta`,
  $localize`:@@countries.mauritania:Mauritania`,
  $localize`:@@countries.mauritius:Mauritius`,
  $localize`:@@countries.mexico:Mexico`,
  $localize`:@@countries.moldova:Moldova`,
  $localize`:@@countries.monaco:Monaco`,
  $localize`:@@countries.mongolia:Mongolia`,
  $localize`:@@countries.montenagro:Montenegro`,
  $localize`:@@countries.montserrat:Montserrat`,
  $localize`:@@countries.morocco:Morocco`,
  $localize`:@@countries.mozambique:Mozambique`,
  $localize`:@@countries.namibia:Namibia`,
  $localize`:@@countries.nepal:Nepal`,
  $localize`:@@countries.netherlands:Netherlands`,
  $localize`:@@countries.netherlandsAntilles:Netherlands Antilles`,
  $localize`:@@countries.newCaledonia:New Caledonia`,
  $localize`:@@countries.newZeeland:New Zealand`,
  $localize`:@@countries.nicaragua:Nicaragua`,
  $localize`:@@countries.niger:Niger`,
  $localize`:@@countries.nigeria:Nigeria`,
  $localize`:@@countries.norway:Norway`,
  $localize`:@@countries.oman:Oman`,
  $localize`:@@countries.pakistan:Pakistan`,
  $localize`:@@countries.palestine:Palestine`,
  $localize`:@@countries.panama:Panama`,
  $localize`:@@countries.papuaNewGuinea:Papua New Guinea`,
  $localize`:@@countries.paraguay:Paraguay`,
  $localize`:@@countries.peru:Peru`,
  $localize`:@@countries.philippines:Philippines`,
  $localize`:@@countries.poland:Poland`,
  $localize`:@@countries.portugal:Portugal`,
  $localize`:@@countries.puertoRico:Puerto Rico`,
  $localize`:@@countries.qatar:Qatar`,
  $localize`:@@countries.reunion:Reunion`,
  $localize`:@@countries.romania:Romania`,
  $localize`:@@countries.russia:Russia`,
  $localize`:@@countries.rwanda:Rwanda`,
  $localize`:@@countries.saintPierre:Saint Pierre &amp; Miquelon`,
  $localize`:@@countries.samoa:Samoa`,
  $localize`:@@countries.sanMorina:San Marino`,
  $localize`:@@countries.satellite:Satellite`,
  $localize`:@@countries.saudiArabia:Saudi Arabia`,
  $localize`:@@countries.senegal:Senegal`,
  $localize`:@@countries.serbia:Serbia`,
  $localize`:@@countries.seychelles:Seychelles`,
  $localize`:@@countries.sierraLeone:Sierra Leone`,
  $localize`:@@countries.singapore:Singapore`,
  $localize`:@@countries.slovakia:Slovakia`,
  $localize`:@@countries.slovenia:Slovenia`,
  $localize`:@@countries.southAfrica:South Africa`,
  $localize`:@@countries.southKorea:South Korea`,
  $localize`:@@countries.spain:Spain`,
  $localize`:@@countries.sriLanka:Sri Lanka`,
  $localize`:@@countries.stKitts:St Kitts &amp; Nevis`,
  $localize`:@@countries.stLucia:St. Lucia`,
  $localize`:@@countries.stVincent:St Vincent`,
  $localize`:@@countries.sudan:Sudan`,
  $localize`:@@countries.suriname:Suriname`,
  $localize`:@@countries.swaziland:Swaziland`,
  $localize`:@@countries.sweden:Sweden`,
  $localize`:@@countries.switzerland:Switzerland`,
  $localize`:@@countries.syria:Syria`,
  $localize`:@@countries.taiwan:Taiwan`,
  $localize`:@@countries.tajikistan:Tajikistan`,
  $localize`:@@countries.tanzania:Tanzania`,
  $localize`:@@countries.thailand:Thailand`,
  $localize`:@@countries.timor:Timor L\'Este`,
  $localize`:@@countries.togo:Togo`,
  $localize`:@@countries.tonga:Tonga`,
  $localize`:@@countries.trinidad:Trinidad &amp; Tobago`,
  $localize`:@@countries.tunisia:Tunisia`,
  $localize`:@@countries.turkey:Turkey`,
  $localize`:@@countries.turkmenistan:Turkmenistan`,
  $localize`:@@countries.turks:Turks &amp; Caicos`,
  $localize`:@@countries.uganda:Uganda`,
  $localize`:@@countries.ukraine:Ukraine`,
  $localize`:@@countries.unitedArabEmirates:United Arab Emirates`,
  $localize`:@@countries.unitedKingdom:United Kingdom`,
  $localize`:@@countries.uruguay:Uruguay`,
  $localize`:@@countries.uzbekistan:Uzbekistan`,
  $localize`:@@countries.venezuela:Venezuela`,
  $localize`:@@countries.vietnam:Vietnam`,
  $localize`:@@countries.virginIslands:Virgin Islands (US)`,
  $localize`:@@countries.yemen:Yemen`,
  $localize`:@@countries.zambia:Zambia`,
  $localize`:@@countries.zimbabwe:Zimbabwe`
];
